import { HttpInterceptorFn } from '@angular/common/http';

import { apiVersioningInterceptor } from './api-versioning-interceptor';
import { connectionLostInterceptor } from './connection-lost.interceptor';
import { provideDuplicateBetplacementInterceptor } from './duplicate-betplacement.interceptor';
import { loadingInterceptor } from './loading.interceptor';
import { sessionExpirationInterceptor } from './session-expiration.interceptor';

export function provideSportsHttpInterceptors(): HttpInterceptorFn[] {
    return [
        sessionExpirationInterceptor,
        apiVersioningInterceptor,
        connectionLostInterceptor,
        loadingInterceptor,
        provideDuplicateBetplacementInterceptor(),
    ];
}
